export default class ExperiencedAfter {
	constructor() {
		this.experiencedAfterId = null;
		this.experiencedAfterTypeId = null;
	}
}
